import { css } from 'styled-components';
import { WHITE, PALE_WHITE_1 } from './Colors';

export const standardMenuSurface = css`
    background: rgba(20, 24, 28, 0.96);
    border: 1px solid ${PALE_WHITE_1};
    color: ${WHITE};
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);
    border-radius: 14px;
    overflow: hidden;
    backdrop-filter: saturate(180%) blur(24px);
    -webkit-backdrop-filter: saturate(180%) blur(24px);
`;
export const standardMenuItem = css`
    display: flex; align-items: center; gap: 8px; width: 100%;
    border: 0; background: transparent; color: ${WHITE}; font: inherit;
    text-align: left; box-sizing: border-box; padding: 10px 12px; cursor: pointer;
    &:hover:not(:disabled), &:focus-visible { background: rgba(255,255,255,.08); }
    &:focus-visible { outline: 2px solid ${WHITE}; outline-offset: -2px; }
    &:disabled { opacity: .45; cursor: default; }
`;
